import { mapState } from 'vuex'
export default {
    data() {
        return {
            tab: 0,
            exchangeType: 0,
            displayClaimCreditModal: false,
            claimData: {
                coins: 2000,
                credit: 100,
            },
            claimedSuccessfulModal: false,
            claimedFailModal: false,
            displayTermAndConditionsModal: false,
            termAndConditionLoading: false,
        }
    },
    computed: {
        ...mapState({
            creditTiers: (state) =>
                state.activities['exchange-reward'].creditTiers,
            itemTiers: (state) => state.activities['exchange-reward'].itemTiers,
            exchangeRewardTermAndCondition: (state) =>
                state.activities['exchange-reward']
                    .exchangeRewardTermAndCondition,
            missionsSettings: (state) =>
                state.activities['mission-reward'].missionsSettings,
            activityWallet: (state) => state.player.activityWallet,
            defaultCurrency: (state) => state.settings.defaultCurrency,
        }),
    },
    mounted() {
        // Fetch all credits tiers
        this.onGetAllTiers()
    },
    methods: {
        onClickClaimCredit() {
            this.displayClaimCreditModal = true
        },
        onClaimCredit() {
            if (Math.floor(Math.random() * 100) % 2 === 0) {
                this.onDisplayClaimSuccessful()
            } else {
                this.onDisplayFailed()
            }
        },
        onDisplayClaimSuccessful() {
            this.claimedSuccessfulModal = true
            setTimeout(() => {
                this.claimedSuccessfulModal = false
            }, 1000)
        },
        onDisplayFailed() {
            this.claimedFailModal = true
        },
        onGetAllTiers() {
            this.$store.dispatch('activities/exchange-reward/getAllTiers', {
                reward_type: 1,
                currency: this.defaultCurrency,
            })
            this.$store.dispatch('activities/exchange-reward/getAllTiers', {
                reward_type: 2,
                currency: this.defaultCurrency,
            })
        },
        async onDisplayTermAndConditionsModal() {
            if (Object.keys(this.exchangeRewardTermAndCondition).length) {
                this.displayTermAndConditionsModal = true
                return
            }
            this.termAndConditionLoading = true
            await this.$store.dispatch(
                'activities/exchange-reward/getExchangeRewardTermAndCondition',
                {
                    currency: this.defaultCurrency,
                }
            )
            this.displayTermAndConditionsModal = true
            this.termAndConditionLoading = false
        },
    },
}
